import posthog from 'posthog-js'

// if (import.meta.env.VITE_POSTHOG_ENABLED === 'true') {
  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST,
    autocapture: false,
    cross_subdomain_cookie: true,
    persistence: 'cookie',
  });

  posthog.register({
    environment: import.meta.env.MODE
  });

// }

export default posthog;
